import { render, staticRenderFns } from "./EndpointAlertsTab.vue?vue&type=template&id=2512e619&scoped=true&"
import script from "./EndpointAlertsTab.vue?vue&type=script&lang=js&"
export * from "./EndpointAlertsTab.vue?vue&type=script&lang=js&"
import style0 from "./EndpointAlertsTab.vue?vue&type=style&index=0&id=2512e619&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2512e619",
  null
  
)

export default component.exports